module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('marker', {
    attrs: {
      "id": _vm.markerId,
      "viewBox": "0 0 10 10",
      "refX": "9",
      "refY": "5",
      "markerUnits": "strokeWidth",
      "markerWidth": "10",
      "markerHeight": "10",
      "orient": "auto-start-reverse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 0 0 L 10 5 L 0 10 z",
      "fill": _vm.color
    }
  })]), _vm._v(" "), (_vm.markers) ? _c('foreignObject', {
    attrs: {
      "width": "105",
      "height": "50",
      "x": _vm.x + 10,
      "y": _vm.y - 70
    }
  }, [_c('div', {
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [_c('div', [_c('span', [_vm._v("x:")]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "value": _vm.value.x
    },
    on: {
      "input": function (e) { return _vm.$emit('input', {
        x: e,
        y: _vm.value.y
      }); }
    }
  }), _vm._v("mm")], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("y:")]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "value": _vm.value.y
    },
    on: {
      "input": function (e) { return _vm.$emit('input', {
        x: _vm.value.x,
        y: e
      }); }
    }
  }), _vm._v("mm")], 1)])]) : _vm._e(), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.x - 10,
      "x2": _vm.x + 10,
      "y1": _vm.y - 10,
      "y2": _vm.y + 10,
      "stroke": _vm.color
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.x - 10,
      "x2": _vm.x + 10,
      "y1": _vm.y + 10,
      "y2": _vm.y - 10,
      "stroke": _vm.color
    }
  }), _vm._v(" "), (_vm.canDelete && _vm.markers) ? _c('foreignObject', {
    attrs: {
      "width": "50",
      "height": "50",
      "x": _vm.x + 110,
      "y": _vm.y - 55
    }
  }, [(_vm.canDelete) ? _c('button', {
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    },
    on: {
      "click": function($event) {
        _vm.$emit('delete');
      }
    }
  }, [_vm._v("x")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-726318e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/components/point.vue
// module id = 3266
// module chunks = 0